document.addEventListener('DOMContentLoaded', initClinicalSliderV2);
document.addEventListener('shopify:section:load', initClinicalSliderV2);

function initClinicalSliderV2() {
  const sliders = document.querySelectorAll('.clinical-slider-v2');
  
  sliders.forEach(slider => {
    // Prevent re-initializing if it's already mounted by Shopify's theme editor
    if (slider.classList.contains('is-initialized')) return;

    const splide = new Splide(slider, {
      perPage: 1,
      type: 'loop',
      pagination: true,
      arrows: false,
      drag: true,
      mediaQuery: 'min',
      breakpoints: {
        769: {
          destroy: true
        }
      }
    });
    
    splide.mount();
  });
}